import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchNodeDescribe,
  fetchNodeEvents,
  fetchNodeList,
} from "./nodesThunks";
import { MinioNode } from "api/nodesApi";

import { IEvent } from "../Tenants/ListTenants/types";
import { MinioNodeDescribe } from "../../api/nodesApi";
import { LoadingStatus } from "common/types";

export interface NodesState {
  nodeList: MinioNode[];
  nodeEvents: IEvent[];
  nodeDescribe: MinioNodeDescribe;
  status: LoadingStatus;
}

const initialState: NodesState = {
  nodeList: [],
  nodeEvents: [],
  status: "idle",
  nodeDescribe: {},
};

export const nodesSlice = createSlice({
  name: "nodes",
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<LoadingStatus>) => {
      state.status = action.payload;
    },
    resetNodeListState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNodeList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchNodeList.fulfilled, (state, action) => {
        state.status = "idle";
        if (action.payload) {
          state.nodeList = action.payload!;
        }
      })
      .addCase(fetchNodeList.rejected, (state, action) => {
        state.status = "failed";
        console.log("failed", action);
      })
      .addCase(fetchNodeEvents.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchNodeEvents.fulfilled, (state, action) => {
        state.status = "idle";
        if (action.payload) {
          state.nodeEvents = action.payload!;
        }
      })
      .addCase(fetchNodeEvents.rejected, (state, action) => {
        state.status = "failed";
        console.log("failed", action);
      })
      .addCase(fetchNodeDescribe.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchNodeDescribe.fulfilled, (state, action) => {
        state.status = "idle";
        if (action.payload) {
          state.nodeDescribe = action.payload!;
        }
      })
      .addCase(fetchNodeDescribe.rejected, (state, action) => {
        state.status = "failed";
        console.log("failed", action);
      });
  },
});

export const { setStatus, resetNodeListState } = nodesSlice.actions;

export default nodesSlice.reducer;
